$(document).ready(function() {

  /*--------------- Scroll to top js -------------------*/
 /*--------------- Scroll to top js -------------------*/
  (function($) { "use strict";

                $(document).ready(function(){"use strict";

                                             var progressPath = document.querySelector('.progress-wrap path');
                                             var pathLength = progressPath.getTotalLength();
                                             progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
                                             progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
                                             progressPath.style.strokeDashoffset = pathLength;
                                             progressPath.getBoundingClientRect();
                                             progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';		
                                             var updateProgress = function () {
                                               var scroll = $(window).scrollTop();
                                               var height = $(document).height() - $(window).height();
                                               var progress = pathLength - (scroll * pathLength / height);
                                               progressPath.style.strokeDashoffset = progress;
                                             }
                                             updateProgress();
                                             $(window).scroll(updateProgress);	
                                             var offset = 50;
                                             var duration = 550;
                                             jQuery(window).on('scroll', function() {
                                               if (jQuery(this).scrollTop() > offset) {
                                                 jQuery('.progress-wrap').addClass('active-progress');
                                               } else {
                                                 jQuery('.progress-wrap').removeClass('active-progress');
                                               }
                                             });				
                                             jQuery('.progress-wrap').on('click', function(event) {
                                               event.preventDefault();
                                               jQuery('html, body').animate({scrollTop: 0}, duration);
                                               return false;
                                             })
                                            });

               })(jQuery); 
  /*-------------------- END ------------------*/
  /*-------------------- END ------------------*/
      jQuery('.nav-toggle').click(function(event) {
        jQuery(this).toggleClass('active');
        event.stopPropagation();
        jQuery(' #al-megamenu .al-mega_menu').slideToggle("2000");
        jQuery('body').toggleClass("open-header");
      });
      jQuery("#al-megamenu .al-mega_menu").on("click", function(event) {
        event.stopPropagation();
        jQuery(this).removeClass('active');
      });
  /*--------------------------- menu hover ---------------------------*/

  jQuery("#al-megamenu .al-mega_menu .al_mm_hassub").hover(
    function () {
      jQuery('body').addClass("menu_hover");
    },
    function () {
      jQuery('body').removeClass("menu_hover");
    }
  );
  /*-------------------- Filter toggle ------------------*/

  jQuery(".filter-toggle").on("click" , function(e){
    e.preventDefault();
    jQuery(this).toggleClass("active");
    jQuery(".filter-toggle-wrap").slideToggle("is-visible");
  })
  var filter = jQuery(this).find('.full_width .sorting_wrapper');
  jQuery(this).find('.filter-toggle').insertBefore(filter);

  /*-------------------- END ------------------*/

  jQuery('.product-single__thumbs img').on('click', function () {
    var src = jQuery(this).attr('src');

    if (src != '') {
      jQuery(this).closest('.product-wrapper').find('img.grid-view-item__image').first().attr('src', src);
    }
    jQuery(this).parent('.grid-item').addClass('open').siblings('.grid-item').removeClass('open');
  });

  /*-------------------- video -------------------*/

  var p = jQuery(".popup_overlay");

  jQuery("#popup_toggle").click(function() {
    jQuery("body").addClass("popup-toggle");
    p.css("display", "block");

  });
  p.click(function(event) {
    e = event || window.event;
    if (e.target == this) {
      jQuery(p).css("display", "none");
      jQuery('body').removeClass('popup-toggle'); 
    }
  });
  jQuery(".popup_close,.homeslider ul.slick-slider .slick-arrow").click(function() {
    p.css("display", "none");
    jQuery('body').removeClass('popup-toggle'); 
  });

  //video popup
  function toggleVideo(state) {
    // if state == 'hide', hide. Else: show video
    var div = document.getElementById("popupVid");
    var iframe = div.getElementsByTagName("iframe")[0].contentWindow;
    //div.style.display = state == 'hide' ? 'none' : '';
    func = state == "hide" ? "pauseVideo" : "playVideo";
    iframe.postMessage(
      '{"event":"command","func":"' + func + '","args":""}',
      "*"
    );
  }

  jQuery("#popup_toggle, .homeslider ul.slick-slider .slick-arrow").click(function() {
    p.css("visibility", "visible").css("opacity", "1");
  });

  p.click(function(event) {
    e = event || window.event;
    if (e.target == this) {
      jQuery(p)
      .css("visibility", "hidden")
      .css("opacity", "0");
      toggleVideo("hide");
    }
  });

  jQuery(".popup_close").click(function() {
    p.css("visibility", "hidden").css("opacity", "0");
    toggleVideo("hide");
  });

  /*------------------------- Checkout button --------------------*/

  jQuery(".shopify-payment-button .shopify-payment-button__button").prepend( jQuery("<i class='mdi mdi-cart-outline'></i>"));

  /*----------------------------------------------*/

  if(jQuery('.header_1 .wrapper-wrap').hasClass('logo_center'))  {
    jQuery('body').addClass('logo_center');
  }
  var w_width = $(window).width();
  $('.slider-content-main-wrap').css('width',w_width);
  if($('.site-header').hasClass('header_transaparent')){
    $('body.template-index').addClass('header_transaparent')
  }

  var img_id = jQuery('.product-single__thumbs .slick-active.slick-current').find('.product-single__thumb').data('id');
  if(jQuery('.product-lightbox-btn').hasClass(img_id)){
    jQuery('.product-lightbox-btn.'+img_id).show();
  }

  /*----------------------- filter ----------------------*/

  jQuery(".filter-left").on("click" , function(e){
    e.preventDefault();
    jQuery(this).toggleClass("active");
    jQuery(".off-canvas.position-left").addClass("is-open");
    jQuery(".js-off-canvas-overlay.is-overlay-fixed").addClass("is-visible is-closable");
  });
  jQuery(".filter-right").on("click" , function(e){
    e.preventDefault();
    jQuery(this).toggleClass("active");
    jQuery(".off-canvas.position-right").addClass("is-open");
    jQuery(".js-off-canvas-overlay.is-overlay-fixed").addClass("is-visible is-closable");
  });
  jQuery(".off-canvas .sidebar_close").on("click" , function(e){
    e.preventDefault();
    jQuery(".off-canvas.position-left").removeClass("is-open");
    jQuery(".off-canvas.position-right").removeClass("is-open");
    jQuery(".js-off-canvas-overlay.is-overlay-fixed").removeClass("is-visible is-closable");
  });
  jQuery(".is-overlay-fixed").on("click" , function(e){
    e.preventDefault();
    jQuery(".filter-left").trigger('click');
    jQuery(".filter-right").trigger('click');
    jQuery(".off-canvas.position-left").removeClass("is-open");
    jQuery(".off-canvas.position-right").removeClass("is-open");
    jQuery(".js-off-canvas-overlay.is-overlay-fixed").removeClass("is-visible is-closable");
  });
  $('.product-360-button a').magnificPopup({
    type: 'inline',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    disableOn: false,
    preloader: false,
    fixedContentPos: false,
    callbacks: {
      open: function() {
        $(window).resize()
      }
    }
  });

  countDownIni('.flip-countdown,.js-flip-countdown'); 

  /*--------------- popup Video ---------------------*/

  $('.popup-video').magnificPopup({
    disableOn: 300,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });

  if ($('a.product-lightbox-btn').length > 0 || $('a.product-video-popup').length > 0) {
    $('.product-single__photos .gallery,.design_2 .product-img').magnificPopup({
      delegate: 'a', // child items selector, by clicking on it popup will open
      type: 'image',
      tLoading: '<div class="please-wait dark"><span></span><span></span><span></span></div>',
      removalDelay: 300,
      closeOnContentClick: true,
      gallery: {
        enabled: true,
        navigateByImgClick: false,
        preload: [0, 1]
      },
      image: {
        verticalFit: false,
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
      },
      callbacks: {
        beforeOpen: function() {
          var productVideo = $('.product-video-popup').attr('href');
          if (productVideo) {
            this.st.mainClass = 'has-product-video';
            var galeryPopup = $.magnificPopup.instance;
            galeryPopup.items.push({
              src: productVideo,
              type: 'iframe'
            });
            galeryPopup.updateItemHTML();
          }
        },
        open: function() {}
      }
      // other options
    });
  }
  $('.design_3 .pro_img').magnificPopup({
    delegate: 'a', // child items selector, by clicking on it popup will open
    type: 'image',
    tLoading: '<div class="please-wait dark"><span></span><span></span><span></span></div>',
    removalDelay: 300,
    closeOnContentClick: true,
    gallery: {
      enabled: true,
      navigateByImgClick: false,
      preload: [0, 1]
    },
    image: {
      verticalFit: false,
      tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
    },
    callbacks: {
      beforeOpen: function() {
        var productVideo = $('.product-video-popup').attr('href');
        if (productVideo) {
          this.st.mainClass = 'has-product-video';
          var galeryPopup = $.magnificPopup.instance;
          galeryPopup.items.push({
            src: productVideo,
            type: 'iframe'
          });
          galeryPopup.updateItemHTML();
        }
      },
      open: function() {}
    }
    // other options
  });
  $('body').on('click', '.product-lightbox-btn', function(e) {
    $('.product-wrapper-owlslider').find('.owl-item.active a').click();
    e.preventDefault();
  });

  /*-------------- Quantity Start -------------------*/ 

  $('.qtyplus').on('click',function(e){
    e.preventDefault();     
    var  input_val = jQuery(this).parents('.qty-box-set').find('.quantity');
    var currentVal = parseInt( jQuery(this).parents('.qty-box-set').find('.quantity').val());
    var update = jQuery('.cart-update .quantity').data("item-id");
    console.log(update);
    if (!isNaN(currentVal)) {
      jQuery(this).parents('.qty-box-set').find('.quantity').val(currentVal + 1);
    } else {
      jQuery(this).parents('.qty-box-set').find('.quantity').val(1);
    }

  });

  $(".qtyminus").on('click',function(e) {
    e.preventDefault();
    var  input_val = jQuery(this).parents('.qty-box-set').find('.quantity');
    var currentVal = parseInt( jQuery(this).parents('.qty-box-set').find('.quantity').val());
    if (!isNaN(currentVal) && currentVal > 1) {
      jQuery(this).parents('.qty-box-set').find('.quantity').val(currentVal - 1);
    } else {
      jQuery(this).parents('.qty-box-set').find('.quantity').val(1);
    }

  });

  /*---------------- END ------------------*/
  $("#navToggle").on('click',function(e) {
    jQuery(this).next('.Site-navigation').slideToggle(500);
  });
  $(".menu_toggle_wrap #navToggle").on('click',function(e) {
    jQuery(this).parent().next('.Site-navigation').slideToggle(500);
  });

  jQuery("body.footer_style_1 .footer_toggle").on("click" , function(e){
    jQuery('#shopify-section-footer-model-1').addClass('toggle-footer'); 
    jQuery("body").addClass("footer1-open");
    e.preventDefault();
  });

  jQuery("body.footer_style_1 .footer_close_toggle").on("click" , function(e){ 
    jQuery('#shopify-section-footer-model-1').removeClass('toggle-footer');
    jQuery("body").removeClass("footer1-open");
    e.preventDefault();
  });
  $(".demo-heading").on("click" , function(e){   
      e.preventDefault();
      $("#shopify-section-demo-list").toggleClass("active");
    });
    $(".demos-close-icon").on("click" , function(e){ 
      $("#shopify-section-demo-list").removeClass("active"); 
    });
  
  /*-------------- Search js ----------------*/


  jQuery(".site-header__search.search-full .serach_icon").on('click',function(e){
    e.preventDefault();
    jQuery(this).toggleClass('active'); 
    jQuery('body').toggleClass('search_full_active'); 
    jQuery( ".search-full-screen" ).slideToggle( "slow" );
    jQuery(".search-bar input.input-group-field").focus();
    jQuery('.full-search-wrapper').addClass('search-overlap');
    jQuery('.myaccount  .dropdown-toggle').removeClass("open");
    jQuery( '.myaccount  .customer_account' ).slideUp( "fast" );  
    jQuery('.site-header .site-header_cart_link').removeClass("active");
    jQuery( "#Sticky-slidedown-cart" ).slideUp( "fast" );   
    jQuery( "#slidedown-cart" ).slideUp( "fast" );
    jQuery('body').toggleClass('search_toggle'); 
    jQuery('body').removeClass('account-toggle');
    jQuery('body').removeClass('cart_toggle');
  });
  jQuery(".site-header__search.search-full .close-search").on('click',function(){
    jQuery('.site-header__search.search-full .serach_icon').removeClass('active');
    jQuery('.full-search-wrapper').removeClass('search-overlap');  
    jQuery('.full-search-wrapper').removeClass('search-overlap');
    jQuery('body').removeClass('search_full_active');
    jQuery('body').removeClass('search_toggle'); 
    jQuery( ".search-full-screen" ).slideUp( "slow" );
  });

  /*------------------------ END -------------------*/
  /*-------------------- Myaccount -----------------*/

  jQuery(".myaccount .dropdown-toggle").on('click',function(event){   
    event.preventDefault();

    jQuery( ".header_1 .customer_account,.header_2 .customer_account,.header_3 .customer_account" ).slideToggle( "fast" );
    jQuery('.myaccount').toggleClass('open');
    jQuery('body').toggleClass('account-toggle');
    if(jQuery( window ).width() < 992) {   
      jQuery( ".header_1 .search_wrapper,.header_2 .search_wrapper" ).slideUp( "fast" );
    }
    jQuery('.site-header__search:not(.search-full) .serach_icon').removeClass('active');
    jQuery('body').removeClass('search_full_active'); 
    jQuery('body').removeClass('currency-open');
    jQuery( ".currencies.flag-dropdown-menu" ).slideUp( "fast" );
    jQuery('body').removeClass('language-open');
    jQuery(".header_language .disclosure__toggle").removeClass('active');
    jQuery(".header_currency .currency_wrapper.dropdown-toggle").removeClass('active');
    jQuery( ".header_language .disclosure-list" ).slideUp( "fast" ); 
    jQuery('.site-header .site-header_cart_link').removeClass("active");    
    jQuery( "#slidedown-cart" ).slideUp( "fast" );
    jQuery( "#Sticky-slidedown-cart" ).slideUp( "fast" );
    jQuery('body').removeClass('search_toggle'); 
    jQuery('body').removeClass('cart_toggle');
  });


  jQuery(".header_language .disclosure__toggle").on("click", function (event) {     
    event.preventDefault();
    jQuery(".customer_account").stop();    
    jQuery('body').toggleClass('language-open');
    jQuery('body').removeClass('currency-open');
    jQuery('body').removeClass('account-toggle');
    jQuery('body').removeClass('cart_active');
    jQuery('.myaccount').removeClass('open');
    jQuery('.currency_wrapper').removeClass('active');
    jQuery( ".disclosure-list" ).slideToggle( "fast" );
    jQuery(this).toggleClass('active');  
    jQuery( ".customer_account" ).slideUp( "fast" );
    jQuery( ".currencies.flag-dropdown-menu" ).slideUp( "fast" );
    jQuery( "#slidedown-cart" ).slideUp( "fast" );
    jQuery( "#Sticky-slidedown-cart" ).slideUp( "fast" );
  });

  $(".header_currency .currency_wrapper.dropdown-toggle").on("click", function (event) {     
    event.preventDefault();
    jQuery(".customer_account").stop(); 
    jQuery('body').toggleClass('currency-open');
    jQuery('body').removeClass('language-open');
    jQuery('body').removeClass('account-toggle');
    jQuery('body').removeClass('cart_active');
    jQuery('.myaccount').removeClass('open');
    jQuery('.disclosure__toggle').removeClass('active');
    jQuery( ".currencies.flag-dropdown-menu" ).slideToggle( "fast" );
    $(this).toggleClass('active'); 
    jQuery( ".customer_account" ).slideUp( "fast" );
    jQuery( ".header_language .disclosure-list" ).slideUp( "fast" ); 
    jQuery( "#slidedown-cart" ).slideUp( "fast" );
    jQuery( "#Sticky-slidedown-cart" ).slideUp( "fast" );
  });
  /*-------------------- END -----------------*/
 var featured = $(".feature-collection .product-grid");
  featured.owlCarousel({
    items : 4 , //10 items above 1000px browser width
    dots: false,
    loop: false,
    nav: true,
    rewind:false,
    autoplay:false,
    responsive: {
      100: {
        items: 1,
        nav: false,
        dots: true,
      },
      480: {
        items: 2,
        nav: false,
        dots: true,
      },
      600: {
        items: 3
      },
      992: {
        items: 4
      },
      1300: {
        items: 4
      },
    }
  });
  
  var p_col = jQuery('.slider-specialproduct').data('col');
  if(jQuery("body").hasClass('disable_menutoggle')){
    $('body.disable_menutoggle .slider-specialproduct').owlCarousel({
      items : p_col , //10 items above 1000px browser width
      loop: false,
      nav: false,
      dots: false,
      rewind:false,
      autoplay:true,
      speed: 3000,
      autoplayTimeout:3000,
      responsive: {
        100: {
          items: 1,
          nav: false,
        },
        375: {
          items: 2,
          nav: false,
        },
        600: {
          items: 3
        },
        992: {
          items: 3
        },
        1300: {
          items: p_col
        },
      }
    });
  }else{
    $('body .slider-specialproduct').owlCarousel({
      items : p_col , //10 items above 1000px browser width
      loop: false,
      nav: false,
      dots: false,
      rewind:false,
      autoplay:true,
      speed: 3000,
      autoplayTimeout:3000,
      responsive: {
        100: {
          items: 1,
          nav: false,
        },
        375: {
          items: 2,
          nav: false,
        },
        600: {
          items: 3
        },
        992: {
          items: 3
        },
        1300: {
          items: p_col
        },
      }
    });
  }  

  $('.slider-specialproduct-wrap').each(function () { 
    if($(this).find('.owl-nav').hasClass('disabled')){
      $(this).find('.customNavigation').hide();
    }else{
      $(this).find('.customNavigation').show();
    }
  });
  $(".slider-specialproduct-wrap .customNavigation .next").click(function(){
    var wrap = $(this).closest('.slider-specialproduct-wrap');
    $(wrap).find('.slider-specialproduct').trigger('next.owl');
  });
  $(".slider-specialproduct-wrap .customNavigation .prev").click(function(){
    var wrap = $(this).closest('.slider-specialproduct-wrap');
    $(wrap).find('.slider-specialproduct').trigger('prev.owl');
  });

  var brandsowl = $("body:not(.rtl) #brands_list_slider");
  var  brandsowlrtl = $("body.rtl #brands_list_slider");
  brandsowl.owlCarousel({
    items : 6 , //10 items above 1000px browser width
    dots: false,
    rewind:false,
    autoplay:true,
    autoplayHoverPause:true,
    nav: true,
    loop: false,
    responsive: {
      100: {
        items: 2,
        nav: false,
      },
      320: {
        items: 2,
        nav: false,
      },
      544: {
        items: 3,
        nav: false,
      },
      992: {
        items: 4
      },
      1200: {
        items: 6
      }
    }
  });
  brandsowlrtl.owlCarousel({
    items : 6 , //10 items above 1000px browser width
    dots: false,
    rewind:true,
    nav: true,
    autoplay:true,
    autoplayHoverPause:true,
    loop: true,
    rtl: true,
    responsive: {
      100: {
        items: 2
      },
      320: {
        items: 2
      },
      544: {
        items: 3
      },
      992: {
        items: 4
      },
      1200: {
        items: 6
      }
    }
  });
  $(".brands_next").click(function(){
    brandsowl.trigger('owl.next');
  });
  $(".brands_prev").click(function(){
    brandsowl.trigger('owl.prev');
  });
  $(".brands_next").click(function(){
    brandsowlrtl.trigger('owl.next');
  });
  $(".brands_prev").click(function(){
    brandsowlrtl.trigger('owl.prev');
  });

  /*-------------------------gallery------------------*/
  var gallery = $("#cmsgallery .image-content");
  gallery.owlCarousel({
    items : 5 , //10 items above 1000px browser width
    dots: false,
    loop: false,
    nav: true,
    rewind:false,
    autoplay:false,
    responsive: {
      100: {
        items: 1
      },
      315: {
        items: 2
      },
      600: {
        items: 3
      },
      992: {
        items: 4
      },
      1300: {
        items: 5
      },
    }
  });
  $('body:not(.rtl) .ttcms-banner .ttbanner-wrap').owlCarousel({
    items :2, //1 items above 1000px browser width
    nav : false,
    dots : false,
    loop: false,
    autoplay:true,
    rtl:false,
    responsive: {
      992: {
        items: 2
      },
      600: {
        items: 2
      },
      100: {
        items:1
      }
    }
  });
  $('body.rtl .ttcms-banner .ttbanner-wrap').owlCarousel({
    items :2, //1 items above 1000px browser width
    nav : false,
    dots : false,
    loop: false,
    autoplay:true,
    rtl:true,
    responsive: {
      992: {
        items: 2
      },
      600: {
        items: 2
      },
      100: {
        items:1
      }
    }
  });

  var offer = $("body:not(.rtl) .ttcmsoffer-block .ttcmsoffer-content");
  offer.owlCarousel({
    items : 1 , //10 items above 1000px browser width
    dots: false,
    loop: true,
    nav: true,
    rewind:true,
    autoplay:true,
    autoplayHoverPause: true,
    responsive: {
      100: {
        items: 1
      },
      1300: {
        items: 1
      }
    }
  });    

  var offer = $("body.rtl .ttcmsoffer-block .ttcmsoffer-content");
  offer.owlCarousel({
    items : 1 , //10 items above 1000px browser width
    dots: false,
    loop: true,
    nav: true,
    rtl:true,
    rewind:true,
    autoplay:true,
    autoplayHoverPause: true,
    responsive: {
      100: {
        items: 1
      },
      1300: {
        items: 1
      }
    }
  });

  var banner = $(".product-thumb .slider-nav");
  banner.owlCarousel({
    items : 1 , //10 items above 1000px browser width
    dots: false,
    loop: true,
    nav: true,
    rewind:true,
    autoplay:true,
    autoplayHoverPause: true,
    responsive: {
      100: {
        items: 1
      },
      481: {
        items: 1
      },
      992: {
        items: 1
      },
      1200: {
        items: 1
      },
      1300: {
        items: 1
      }
    }
  });     
  $('body .about-services .block_content').owlCarousel({
    items :3, //1 items above 1000px browser width
    nav : false,
    dots : true,
    loop: false,
    autoplay:false,
    rewindNav:true,
    responsive: {
      1200: {
        items: 3
      },
      768: {
        items: 3
      },
      481: {
        items: 2
      },
      100: {
        items: 1
      }
    }
  });
  $('body:not(.rtl) #al-megamenu .list_product_menu_content').owlCarousel({
    items : 3, //1 items above 1000px browser width
    nav : false,
    autoPlay:true,
    autoplaySpeed:1000,
    stopOnHover: false,
    loop: false,
    dots : true,
    responsive: {
      768: {
        items: 3
      },
      360: {
        items: 2
      },
      100: {
        items: 1
      }
    }
  });
  $('body.rtl #al-megamenu .list_product_menu_content').owlCarousel({
    items : 3, //1 items above 1000px browser width
    nav : true,
    autoPlay:true,
    autoplaySpeed:1000,
    rtl: true,
    stopOnHover: false,
    loop: false,
    dots : true,
    responsive: {
      768: {
        items: 3
      },
      360: {
        items: 2
      },
      100: {
        items: 1
      }
    }
  });

  $(".full_gallery_slider.owl-carousel").on("changed.owl.carousel",function(e){
    var element = e.target; // DOM element, in this example .owl-carousel
    var items = e.item.count; // Number of items
    var item = e.relatedTarget.relative(e.item.index) + 1; 

    $(element).parent().find('.num').html(item + "/" + items)
  }),

  $('body:not(.rtl) .full_gallery_slider.owl-carousel').owlCarousel({
    loop:true,
    startPosition:0,
    center: true,
    dots:true,
    items:1,
    lazyLoad: true,
    nav:false,
    responsive:{
      100:{
        items:1
      },
      767:{
        items:1
      },
      991:{
        items:3
      },
      1199:{
        items:3
      },
      1299:{
        items:3
      }
    }
  });
  $('body.rtl .full_gallery_slider.owl-carousel').owlCarousel({
    loop:true,
    startPosition:0,
    center: true,
    dots:true,
    items:3,
    rtl:true,
    lazyLoad: true,
    nav:false,
    responsive:{
      100:{
        items:1
      },
      767:{
        items:1
      },
      991:{
        items:3
      },
      1199:{
        items:3
      },
      1299:{
        items:3
      }
    }
  });

  $('body:not(.rtl) .tttestimonial-wrap .testimonials_wrap').owlCarousel({
    items: 1, //1 items above 1000px browser width
    nav: true,
    navText: [
      "<i class='mdi-chevron-left mdi'></i>",
      "<i class='mdi-chevron-right mdi'></i>"
    ],
    dots: false,
    loop: false,
    autoplay: false,
    autoplayHoverPause: true,
    responsive: {
      1279: {
        items: 1
      },
      1250: {
        items: 1
      },
      600: {
        items: 1
      }
    }
  });
  $('body.rtl .tttestimonial-wrap .testimonials_wrap').owlCarousel({
    items: 1, //1 items above 1000px browser width
    nav: true,
    navText: [
      "<i class='mdi-chevron-left mdi'></i>",
      "<i class='mdi-chevron-right mdi'></i>"
    ],
    dots: false,
    loop: false,
    autoplay: false,
    autoplayHoverPause: true,
    responsive: {
      1279: {
        items: 1
      },
      1250: {
        items: 1
      },
      600: {
        items: 1
      }
    }
  });

  $(".category-feature .owl-item").hover(function(){
    $(".category-feature .owl-item.center").addClass("changeStyle");
  });

  $( ".category-feature .owl-item" ).mouseleave(function() {
    $( ".category-feature .owl-item.center" ).removeClass("changeStyle");
  });
  $('body:not(.rtl) .widget_top_rated_products .top-products').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 3,
    arrows: true,
    dots: false,
    infinite: false,
    appendArrows: $('.slick-nav'),
    prevArrow: '<button type="button" class="slick-prev"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.73546 15.3236C8.7385 15.0422 8.61938 14.8592 8.45163 14.6915C6.67635 12.9192 4.90351 11.1452 3.13005 9.37172C2.72832 8.96999 2.33206 8.56157 1.92121 8.16956C1.7875 8.04193 1.77899 7.97751 1.91695 7.84016C4.07634 5.6911 6.22904 3.53597 8.38296 1.38145C8.44191 1.32249 8.50329 1.26536 8.55739 1.20216C8.80961 0.907998 8.79381 0.484993 8.52335 0.21393C8.2535 -0.0571327 7.83171 -0.0729332 7.53513 0.178073C7.47739 0.226694 7.42512 0.282 7.37164 0.335483C5.02445 2.68206 2.67727 5.02925 0.330691 7.37643C-0.109331 7.81645 -0.109939 8.1878 0.328259 8.62539C2.69672 10.9945 5.06456 13.3629 7.43363 15.7308C7.88702 16.1841 8.55252 16.0444 8.71054 15.4658C8.72634 15.408 8.73181 15.3473 8.73607 15.3229L8.73546 15.3236Z"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.264541 15.3236C0.261502 15.0422 0.380623 14.8592 0.548366 14.6915C2.32365 12.9192 4.09649 11.1452 5.86995 9.37172C6.27168 8.96999 6.66794 8.56157 7.07879 8.16956C7.2125 8.04193 7.22101 7.97751 7.08305 7.84016C4.92366 5.6911 2.77096 3.53597 0.617043 1.38145C0.55809 1.32249 0.496706 1.26536 0.442615 1.20216C0.190393 0.907998 0.206195 0.484993 0.47665 0.21393C0.746497 -0.0571327 1.16829 -0.0729332 1.46487 0.178073C1.52261 0.226694 1.57488 0.282 1.62836 0.335483C3.97555 2.68206 6.32273 5.02925 8.66931 7.37643C9.10933 7.81645 9.10994 8.1878 8.67174 8.62539C6.30328 10.9945 3.93544 13.3629 1.56637 15.7308C1.11298 16.1841 0.447478 16.0444 0.289459 15.4658C0.273657 15.408 0.268187 15.3473 0.263933 15.3229L0.264541 15.3236Z"/></svg></button>',
    responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
    ],
  });
  $('body.rtl .widget_top_rated_products .top-products').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 3,
    arrows: true,
    dots: false,
    infinite: false,
    prevArrow: '<button type="button" class="slick-prev"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.73546 15.3236C8.7385 15.0422 8.61938 14.8592 8.45163 14.6915C6.67635 12.9192 4.90351 11.1452 3.13005 9.37172C2.72832 8.96999 2.33206 8.56157 1.92121 8.16956C1.7875 8.04193 1.77899 7.97751 1.91695 7.84016C4.07634 5.6911 6.22904 3.53597 8.38296 1.38145C8.44191 1.32249 8.50329 1.26536 8.55739 1.20216C8.80961 0.907998 8.79381 0.484993 8.52335 0.21393C8.2535 -0.0571327 7.83171 -0.0729332 7.53513 0.178073C7.47739 0.226694 7.42512 0.282 7.37164 0.335483C5.02445 2.68206 2.67727 5.02925 0.330691 7.37643C-0.109331 7.81645 -0.109939 8.1878 0.328259 8.62539C2.69672 10.9945 5.06456 13.3629 7.43363 15.7308C7.88702 16.1841 8.55252 16.0444 8.71054 15.4658C8.72634 15.408 8.73181 15.3473 8.73607 15.3229L8.73546 15.3236Z"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.264541 15.3236C0.261502 15.0422 0.380623 14.8592 0.548366 14.6915C2.32365 12.9192 4.09649 11.1452 5.86995 9.37172C6.27168 8.96999 6.66794 8.56157 7.07879 8.16956C7.2125 8.04193 7.22101 7.97751 7.08305 7.84016C4.92366 5.6911 2.77096 3.53597 0.617043 1.38145C0.55809 1.32249 0.496706 1.26536 0.442615 1.20216C0.190393 0.907998 0.206195 0.484993 0.47665 0.21393C0.746497 -0.0571327 1.16829 -0.0729332 1.46487 0.178073C1.52261 0.226694 1.57488 0.282 1.62836 0.335483C3.97555 2.68206 6.32273 5.02925 8.66931 7.37643C9.10933 7.81645 9.10994 8.1878 8.67174 8.62539C6.30328 10.9945 3.93544 13.3629 1.56637 15.7308C1.11298 16.1841 0.447478 16.0444 0.289459 15.4658C0.273657 15.408 0.268187 15.3473 0.263933 15.3229L0.264541 15.3236Z"/></svg></button>',
    responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
    ],
  });
  $('.testimonial-section').owlCarousel({
    loop:true,
    dots : false,
    responsiveClass:true,
    items:1,
    autoplayHoverPause: false,
    lazyLoad: true,
    smartSpeed: 1000,
    autoplayTimeout: 3000,
    responsive:{
        0:{
            dots : true,
            nav:false            
        },
        600:{
            nav:true
        }
    }
})

 $('.design_2_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    prevArrow: '<button type="button" class="slick-prev"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.73546 15.3236C8.7385 15.0422 8.61938 14.8592 8.45163 14.6915C6.67635 12.9192 4.90351 11.1452 3.13005 9.37172C2.72832 8.96999 2.33206 8.56157 1.92121 8.16956C1.7875 8.04193 1.77899 7.97751 1.91695 7.84016C4.07634 5.6911 6.22904 3.53597 8.38296 1.38145C8.44191 1.32249 8.50329 1.26536 8.55739 1.20216C8.80961 0.907998 8.79381 0.484993 8.52335 0.21393C8.2535 -0.0571327 7.83171 -0.0729332 7.53513 0.178073C7.47739 0.226694 7.42512 0.282 7.37164 0.335483C5.02445 2.68206 2.67727 5.02925 0.330691 7.37643C-0.109331 7.81645 -0.109939 8.1878 0.328259 8.62539C2.69672 10.9945 5.06456 13.3629 7.43363 15.7308C7.88702 16.1841 8.55252 16.0444 8.71054 15.4658C8.72634 15.408 8.73181 15.3473 8.73607 15.3229L8.73546 15.3236Z"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.264541 15.3236C0.261502 15.0422 0.380623 14.8592 0.548366 14.6915C2.32365 12.9192 4.09649 11.1452 5.86995 9.37172C6.27168 8.96999 6.66794 8.56157 7.07879 8.16956C7.2125 8.04193 7.22101 7.97751 7.08305 7.84016C4.92366 5.6911 2.77096 3.53597 0.617043 1.38145C0.55809 1.32249 0.496706 1.26536 0.442615 1.20216C0.190393 0.907998 0.206195 0.484993 0.47665 0.21393C0.746497 -0.0571327 1.16829 -0.0729332 1.46487 0.178073C1.52261 0.226694 1.57488 0.282 1.62836 0.335483C3.97555 2.68206 6.32273 5.02925 8.66931 7.37643C9.10933 7.81645 9.10994 8.1878 8.67174 8.62539C6.30328 10.9945 3.93544 13.3629 1.56637 15.7308C1.11298 16.1841 0.447478 16.0444 0.289459 15.4658C0.273657 15.408 0.268187 15.3473 0.263933 15.3229L0.264541 15.3236Z"/></svg></button>',
  });
 $('.category_feature').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    prevArrow: '<button type="button" class="slick-prev"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.73546 15.3236C8.7385 15.0422 8.61938 14.8592 8.45163 14.6915C6.67635 12.9192 4.90351 11.1452 3.13005 9.37172C2.72832 8.96999 2.33206 8.56157 1.92121 8.16956C1.7875 8.04193 1.77899 7.97751 1.91695 7.84016C4.07634 5.6911 6.22904 3.53597 8.38296 1.38145C8.44191 1.32249 8.50329 1.26536 8.55739 1.20216C8.80961 0.907998 8.79381 0.484993 8.52335 0.21393C8.2535 -0.0571327 7.83171 -0.0729332 7.53513 0.178073C7.47739 0.226694 7.42512 0.282 7.37164 0.335483C5.02445 2.68206 2.67727 5.02925 0.330691 7.37643C-0.109331 7.81645 -0.109939 8.1878 0.328259 8.62539C2.69672 10.9945 5.06456 13.3629 7.43363 15.7308C7.88702 16.1841 8.55252 16.0444 8.71054 15.4658C8.72634 15.408 8.73181 15.3473 8.73607 15.3229L8.73546 15.3236Z"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.264541 15.3236C0.261502 15.0422 0.380623 14.8592 0.548366 14.6915C2.32365 12.9192 4.09649 11.1452 5.86995 9.37172C6.27168 8.96999 6.66794 8.56157 7.07879 8.16956C7.2125 8.04193 7.22101 7.97751 7.08305 7.84016C4.92366 5.6911 2.77096 3.53597 0.617043 1.38145C0.55809 1.32249 0.496706 1.26536 0.442615 1.20216C0.190393 0.907998 0.206195 0.484993 0.47665 0.21393C0.746497 -0.0571327 1.16829 -0.0729332 1.46487 0.178073C1.52261 0.226694 1.57488 0.282 1.62836 0.335483C3.97555 2.68206 6.32273 5.02925 8.66931 7.37643C9.10933 7.81645 9.10994 8.1878 8.67174 8.62539C6.30328 10.9945 3.93544 13.3629 1.56637 15.7308C1.11298 16.1841 0.447478 16.0444 0.289459 15.4658C0.273657 15.408 0.268187 15.3473 0.263933 15.3229L0.264541 15.3236Z"/></svg></button>',
    responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
  ],
  });

  jQuery(".spr-summary-actions-newreview").on('click',function(e) {
    e.preventDefault();
    jQuery(".spr-content").slideToggle( "slow" );
  });

  $(".pro_btn.quick-view-wrap > a,.pro_btn.add_tocart form > a,.pro_btn.add-to-compare .add-in-compare-js").click(function(){$(this).addClass("loading");setTimeout(function(){$(".pro_btn.quick-view-wrap > a,.pro_btn.add_tocart form > a, .pro_btn.add-to-compare .add-in-compare-js").removeClass("loading")},2000)});

  var prevScrollpos = window.pageYOffset;
window.onscroll = function() {
    var currentScrollPos = window.pageYOffset;
    if (prevScrollpos > currentScrollPos) {
        document.getElementById("header-sticky").style.top = "0";
    } else {
        document.getElementById("header-sticky").style.top = "-160px";
    }
    prevScrollpos = currentScrollPos;
}
  
});

function moremenu() {     
  var max_elem = 4;
  var items = $("#accessibleNav > li");
  var surplus = items.slice(max_elem, items.length);
  surplus.wrapAll('<li class="more_menu site-nav--has-dropdown menu-item-depth-0"><ul class="top-link sub-nav__dropdown sub-menu mobile-nav__sublist">');
  jQuery('.more_menu').prepend('<a href="#" class="level-top topmega-menu-link">More</a>');
  jQuery('.more_menu').mouseover(function(){
    jQuery(this).children('ul').addClass('shown-link');
    jQuery('body').addClass('menu-open');
  })
  jQuery('.more_menu').mouseout(function(){
    jQuery(this).children('ul').removeClass('shown-link');
    jQuery('body').removeClass('menu-open');      
  });
  $("#accessibleNav").css('display', 'block');
}
jQuery(document).ready(function(){
  moremenu();
});

jQuery(window).scroll(function () {
  if(jQuery(document).height() > jQuery(window).height()){
    var scroll = jQuery(window).scrollTop();
    if (scroll > 100) {
      jQuery("#GotoTop").fadeIn();
    } else {
      jQuery("#GotoTop").fadeOut();
    }
  }
});
jQuery(function(){
  var liCount = jQuery('.header_style_6 #al-megamenu .al_menus_ul >li').length / 2;
  var liCount = Math.floor(liCount);
  jQuery(".header_style_6 #al-megamenu .al_menus_ul >li:lt("+liCount+")").addClass('left-link');
  jQuery(".header_style_6 #al-megamenu .al_menus_ul >li:not('.left-link')").addClass('right-link');
  jQuery('.header_style_6 #al-megamenu .al_menus_ul >li.left-link').wrapAll('<div class="menu-left"></div>');
  jQuery('.header_style_6 #al-megamenu .al_menus_ul >li.right-link').wrapAll('<div class="menu-right"></div>');
});
/*--------- Start js for userinfo -------------*/

function footercolumn() { 
  if ($(window).width() <= 991) {
    jQuery("#shopify-section-footer-model-3 .footer-column.links").insertBefore("#shopify-section-footer-model-3 .footer-column.contactus");
  } 
  else if ($(window).width() >= 992) {
    jQuery("#shopify-section-footer-model-3 .footer-column.links").insertAfter("#shopify-section-footer-model-3 .social-icons-list-main");
  }
}
jQuery(document).ready(function() {
  footercolumn();
});
jQuery(window).resize(function() {
  footercolumn();
});
/*------------------ END -----------------------*/
function responsiveMenu(){
  if(jQuery(window).width() < 992) {

    jQuery('.sub-nav__dropdown').css('display','none');   
    jQuery(".header_style_6 .main-header .header_logo_wrap").insertAfter(".header_style_6 .main-header .right-icon");   
    jQuery(".header_1 .menu_toggle_wrap").insertBefore( ".header_1 .header_logo_wrap" );
    jQuery(".header_1 .top_header_1_link").appendTo( ".header_1 .al-mega_menu" ); 
    jQuery(".header_1 .header-service").insertAfter( ".header_1 .top_header_1_link" );
    jQuery(".header_1 .al_menus_ul1 .al_menu_item.item").appendTo(".header_1 .al-megamenu .al-mega_menu .al_menus_ul");
    jQuery(".header_1 .header-middle .left-nav").insertAfter(".header_1 .al-megamenu .al-mega_menu .al_menus_ul");
    jQuery(".header_style_8 .left-nav").insertAfter(".header_style_8 .al_menus_ul");
  }
  else { 
    jQuery(".header_1 .menu_toggle_wrap").appendTo(".header_1 .menu_wrapper");
    jQuery(".header_1 .top_header_1_link").prependTo( ".header_1 .top_header_1" );
    jQuery(".header_1 .header-service").insertAfter( ".header_1 .top-header" );
    jQuery(".header_1 .al_menus_ul .al_menu_item.item").prependTo(".header_1 .al-megamenu1 .al-mega_menu1 .al_menus_ul1");
    jQuery(".header_1 .left-nav").prependTo(".header_1 .header-middle .middle-content");   
    jQuery(".header_style_6 .header_logo_wrap").insertAfter(".header_style_6 #al-megamenu .al_menus_ul .menu-left");
    jQuery(".header_style_8 .left-nav").insertAfter(".header_style_8 #shopify-section-al-megamenu");
  }
}

jQuery(document).ready(function() {
  responsiveMenu();

  jQuery(".product-write-review").on('click',function(e) {
    e.preventDefault();
    $('a[href=\'#tab-2\']').trigger('click');
    jQuery('html, body').animate({
      scrollTop: jQuery(".product_tab_wrapper").offset().top-150
    }, 1000);
  });
});

jQuery(window).resize(function() {
  responsiveMenu();
  var w_width = $(window).width();
  $('.slider-content-main-wrap').css('width',w_width);
});

function height(){
  var maxHeight = $(".design_3 .product-block .product-img .image,.design_2 .product-block .image,.design_1 .product-single__thumbs a.product-single__thumbnail img").height();
  $(".design_3 .product-block .product-img .extra-video,.design_2 .product-block .extra-video,.design_1 .product-single__thumbs a.product-single__thumbnail.extra-video img").height(maxHeight);
  $(".design_3 .product-block .product-img .video,.design_2 .product-block .video,.design_1 .product-single__thumbs a.product-single__thumbnail.video img").height(maxHeight);
  $(".design_3 .product-block .product-img .model,.design_2 .product-block .model,.design_1 .product-single__thumbs a.product-single__thumbnail.model img").height(maxHeight);
}
$(document).ready(function(){height();});
$(window).resize(function(){height();});
$(window).scroll(function() {height();});

function footerToggle() {
  if(jQuery( window ).width() < 992) {   
    jQuery('.sidebar .collection_sidebar .sidebar-block').insertAfter('.filter-wrapper');
    jQuery('#shopify-section-footer-model-1 .footer-column.links').appendTo('#shopify-section-footer-model-1 .footer-content');
    jQuery('#shopify-section-footer-model-2 .footer-column.links').insertAfter('#shopify-section-footer-model-2 .footer-logo-content');
    jQuery(".right-sidebar.sidebar .widget > h4,.left-sidebar.sidebar .widget > h4,.blog-section .sidebar .widget > h4").addClass( "toggle" );
    jQuery(".right-sidebar.sidebar .widget,.left-sidebar.sidebar .widget,.blog-section .sidebar .widget").children(':nth-child(2)').css( 'display', 'none' );
    jQuery(".right-sidebar.sidebar .widget.active,.left-sidebar.sidebar .widget.active,.blog-section .sidebar .widget.active").children(':nth-child(2)').css( 'display', 'block' );
    jQuery(".right-sidebar.sidebar .widget > h4.toggle,.left-sidebar.sidebar .widget > h4.toggle,.blog-section .sidebar .widget > h4.toggle").unbind("click");
    jQuery(".right-sidebar.sidebar .widget > h4.toggle,.left-sidebar.sidebar .widget > h4.toggle,.blog-section .sidebar .widget > h4.toggle").on('click',function() {
      jQuery(this).parent().toggleClass('active').children(':nth-child(2)').slideToggle( "fast" );
    });   
    jQuery(".collection_right .sidebar-block .widget > h4,.collection_left .sidebar-block .widget > h4,.filter-toggle-wrap .sidebar-block .widget > h4").addClass( "toggle" );
    jQuery(".collection_right .sidebar-block .widget,.collection_left .sidebar-block .widget,.filter-toggle-wrap .sidebar-block .widget ").children(':nth-child(2)').css( 'display', 'none' );
    jQuery(".collection_right .sidebar-block .widget.active,.collection_left .sidebar-block .widget.active,.filter-toggle-wrap .sidebar-block .widget.active").children(':nth-child(2)').css( 'display', 'block' );
    jQuery(".collection_right .sidebar-block .widget > h4.toggle,.collection_left .sidebar-block .widget > h4.toggle,.filter-toggle-wrap .sidebar-block .widget > h4.toggle").unbind("click");
    jQuery(".collection_right .sidebar-block .widget > h4.toggle,.collection_left .sidebar-block .widget > h4.toggle,.filter-toggle-wrap .sidebar-block .widget > h4.toggle").on('click',function() {
      jQuery(this).parent().toggleClass('active').children(':nth-child(2)').slideToggle( "fast" );
    });  
  }else {
    jQuery('.sidebar-block').prependTo('.collection_sidebar');
    jQuery('#shopify-section-footer-model-1 .footer-column.links').insertBefore('#shopify-section-footer-model-1 .copyright');
  	jQuery('#shopify-section-footer-model-2 .footer-column.links').insertBefore('#shopify-section-footer-model-2 .copyright');
    jQuery(".sidebar .widget > h4,.sidebar-block .widget > h4").unbind("click");
    jQuery(".sidebar .widget > h4,.sidebar-block .widget > h4").removeClass( "toggle" );
    jQuery(".sidebar .widget,.sidebar-block .widget").children(':nth-child(2)').css( 'display', 'block' );
  }
}
jQuery(document).ready(function() {
  footerToggle();
});
jQuery(window).resize(function() {
  footerToggle();
});

function splitStr(string,seperator){
  return string.split(seperator);
}

function countDownIni(countdown) {
  $(countdown).each(function () {
    var countdown = $(this);
    var promoperiod;
    if (countdown.attr('data-promoperiod')) {
      promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
    } else if (countdown.attr('data-countdown')) {
      promoperiod = countdown.attr('data-countdown');
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      $(this).addClass('countdown-block');
      countdown.countdown(promoperiod, function (event) {
        // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
        countdown.html(event.strftime('<span><span class="left-txt">Left</span><span>%D</span><span class="time-txt">Days</span></span>' + '<span><span>%H</span><span class="time-txt">Hrs</span></span>' + '<span><span>%M</span><span class="time-txt">Min</span></span>' + '<span><span class="second">%S</span><span class="time-txt">Sec</span></span>'));
      });
    }

  });
}

function hb_animated_contents() {
  $(".hb-animate-element:in-viewport").each(function (i) {
    var $this = $(this);
    if (!$this.hasClass('hb-in-viewport')) {
      setTimeout(function () {
        $this.addClass('hb-in-viewport');
      }, 180 * i);
    }
  });
}

$(window).scroll(function () {
  hb_animated_contents();
});
$(window).load(function () {
  hb_animated_contents();
});

function sidebarsticky() { 
  if ($(document).width() <= 1199) {
    jQuery('.left-sidebar.sidebar,.right-sidebar.sidebar.collection_right,.collection_left').theiaStickySidebar({
      additionalMarginBottom: 30,
      additionalMarginTop: 30
    });
  } 
  else if ($(document).width() >= 1200) {
    jQuery('.left-sidebar.sidebar,.right-sidebar.sidebar,.collection_right,.collection_left').theiaStickySidebar({
      additionalMarginBottom: 30,
      additionalMarginTop: 130
    });
  }
}
jQuery(document).ready(function() {
  sidebarsticky();
});
jQuery(window).resize(function() {
  sidebarsticky();
});
/* responsive accordian menu*/
jQuery(function() {
  var Accordion = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;
    $('ul.al_menus_ul1 > li.al_mm_hassub').addClass('active');
    // Variables privadas
    var links = this.el.find('li.al_mm_hassub .mobile-nav__sublist-trigger');
    // Evento
    links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
  }
  Accordion.prototype.dropdown = function(e) {
    e.preventDefault();
    var $el = e.data.el;
    $this = $(this),
      $next = $this.next();

    $next.slideToggle();
    $this.parent().toggleClass('open');

    if (!e.data.multiple) {
      $el.find('li.al_mm_hassub .al_sub_menu_wrap').not($next).slideUp().parent().removeClass('open');
    };
  }	
  var accordion = new Accordion($('.al_menus_ul1'), false);
});
$(function() {
  if(!$('body').hasClass('fullnav-open'))  {
  var Accordion = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;
    // Variables privadas
    var links = this.el.find('li.al_mm_hassub .mobile-nav__sublist-trigger');
    // Evento
    links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
  }

  Accordion.prototype.dropdown = function(e) {
    var $el = e.data.el;
    $this = $(this),
      $next = $this.next();

    $next.slideToggle();
    $this.parent().toggleClass('open');

    if (!e.data.multiple) {
      $el.find('li.al_mm_hassub .al_sub_menu_wrap').not($next).slideUp().parent().removeClass('open');
    };
  }	

  var accordion = new Accordion($('.al_menus_ul'), false);
  }
});
$(function() {
  var Accordions = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    // Variables privadas
    var link = this.el.find('.toggle');
    // Evento
    link.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
  }

  Accordions.prototype.dropdown = function(e) {
    var $el = e.data.el;
    $this = $(this),
      $next = $this.next();

    $next.slideToggle();
    $this.parent().toggleClass('active');

    if (!e.data.multiple) {
      $el.find('.inline-list').not($next).slideUp().parent().removeClass('active');
    };
  }	

  var accordions = new Accordions($('.footer-column'), false);

});
